import React, { useState } from 'react';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Team from './components/Team';
import AdminPanel from './components/AdminPanel';
import { NotificationProvider } from './components/NotificationSystem';
import WalletConnector from './components/WalletConnector'; // YOUR WORKING CONNECTOR
import { useAuth } from './hooks/useAuth';
import { NETWORK_CONFIGS } from './utils/constants';
import './styles/global.css';
import './styles/components.css';
import './styles/animations.css';
import './styles/team.css';
import './styles/Dashboard.css';

// Use opBNB Mainnet (204)
const SELECTED_NETWORK = NETWORK_CONFIGS.OPBNB_MAINNET;
const REQUIRED_CHAIN_ID = 204;

function AppContent() {
  const [activeTab, setActiveTab] = useState('dashboard');
  
  // Single source of truth for wallet state
  const [account, setAccount] = useState(''); // Initialize as empty string
  const [provider, setProvider] = useState(null);
  const [signer, setSigner] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  
  // Auth check - only when account is a valid string
  const { isAdminOrOwner } = useAuth(account || '', SELECTED_NETWORK);

  // Handle wallet connection from YOUR WalletConnector
  const handleWalletConnect = async (walletAccount, walletProvider, walletType) => {
    console.log('Wallet connected:', walletAccount, 'Type:', walletType);
    
    try {
      setAccount(walletAccount);
      setProvider(walletProvider);
      setIsConnected(true);
      
      // Get signer
      const walletSigner = walletProvider.getSigner();
      setSigner(walletSigner);
      
    } catch (error) {
      console.error('Error setting up wallet:', error);
    }
  };

  const handleWalletDisconnect = () => {
    console.log('Wallet disconnected');
    setAccount('');
    setProvider(null);
    setSigner(null);
    setIsConnected(false);
  };

  return (
    <div className="app">
      <div className="stars"></div>
      <div className="galaxy-bg"></div>
      
      <Header />

      <main className="main-content">
        {!isConnected ? (
          <div className="welcome-screen">
            <div className="welcome-container">
              <img src="/logo.png" alt="7Universe" className="logo-large" />
              <h1 className="welcome-title">Welcome to 7Universe</h1>
              <p className="welcome-subtitle">
                Connect your wallet to explore the universe of opportunities
              </p>
              
              <div className="welcome-features">
                <div className="welcome-feature">
                  <h4>Smart Matrix System</h4>
                  <p>Advanced binary matrix with spillover rewards</p>
                </div>
                <div className="welcome-feature">
                  <h4>Multiple Income Streams</h4>
                  <p>Sponsor income, level bonuses, and pool distributions</p>
                </div>
                <div className="welcome-feature">
                  <h4>Galaxy Pools</h4>
                  <p>Four premium pools with massive rewards</p>
                </div>
              </div>
              
              <div className="wallet-connect-container">
                <WalletConnector
                  onConnect={handleWalletConnect}
                  onDisconnect={handleWalletDisconnect}
                  requiredChainId={REQUIRED_CHAIN_ID}
                />
              </div>
              
              <div style={{ marginTop: '24px', color: 'var(--secondary-text)', fontSize: '0.9rem' }}>
                <p>Powered by {SELECTED_NETWORK.chainName}</p>
                <p>Supports MetaMask, TrustWallet, SafePal & more</p>
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* Header wallet display */}
            <div className="wallet-status-header">
              <WalletConnector
                onConnect={handleWalletConnect}
                onDisconnect={handleWalletDisconnect}
                requiredChainId={REQUIRED_CHAIN_ID}
              />
            </div>

            <nav className="tab-navigation">
              <button 
                className={`tab-btn ${activeTab === 'dashboard' ? 'active' : ''}`}
                onClick={() => setActiveTab('dashboard')}
              >
                Dashboard
              </button>
              
              <button 
                className={`tab-btn ${activeTab === 'team' ? 'active' : ''}`}
                onClick={() => setActiveTab('team')}
              >
                Team
              </button>
              
              {isAdminOrOwner && (
                <button 
                  className={`tab-btn ${activeTab === 'admin' ? 'active' : ''}`}
                  onClick={() => setActiveTab('admin')}
                >
                  Admin
                </button>
              )}
            </nav>

            <div className="tab-content">
              {activeTab === 'dashboard' && (
                <Dashboard 
                  account={account} 
                  provider={provider}
                  signer={signer}
                  network={SELECTED_NETWORK} 
                />
              )}
              {activeTab === 'team' && (
                <Team 
                  account={account} 
                  provider={provider}
                  signer={signer}
                  network={SELECTED_NETWORK} 
                />
              )}
              {activeTab === 'admin' && isAdminOrOwner && (
                <AdminPanel 
                  account={account} 
                  provider={provider}
                  signer={signer}
                  network={SELECTED_NETWORK} 
                />
              )}
            </div>
          </>
        )}
      </main>

      <footer className="app-footer">
        <p>&copy; 2025 7Universe. Powered by {SELECTED_NETWORK.chainName}.</p>
      </footer>
    </div>
  );
}

function App() {
  return (
    <NotificationProvider>
      <AppContent />
    </NotificationProvider>
  );
}

export default App;